import React from 'react'

import css from '@styled-system/css'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconBase, { Path } from '@/components/IconBase'

const directions = ({ isRtl } = {}) => ({
  left: isRtl ? 180 : 360,
  right: isRtl ? 360 : 180,
  up: 90,
  down: 270,
})

const ArrowBox = styled(IconBase)(({ $direction, theme: { isRtl } }) =>
  css({
    svg: {
      transition: '0.3s',
      transform: `rotate(${directions({ isRtl })?.[$direction] ?? 0}deg)`,
    },
  }),
)

function ArrowBold({
  color = 'icon.primary',
  direction = 'left',
  stroke = '2',
  ...props
}) {
  return (
    <ArrowBox viewBox='-2 0 18 18' $direction={direction} {...props}>
      <Path
        d='M10 17L2 9.5L10 2'
        stroke={color}
        strokeWidth={stroke}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </ArrowBox>
  )
}

ArrowBold.propTypes = {
  direction: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
}

export default ArrowBold
